/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const FeedingIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 24 24'
			style={{
				enableBackground: 'new 0 0 24 24'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<style>{`.st0{fill: ${color}}`}</style>
			<g id='outline' transform='translate(-1.981 -2)'>
				<path
					id='Path_39532'
					className='st0'
					d='M24.1 12.4c-.3-.1-.7-.2-1.1-.2h-.2l.1-.1c.3-.3.5-.7.6-1.2.2-1 .3-2.9-1-3.6-.5-.3-1.2-.4-1.8-.2-.8.2-1.5.8-1.9 1.5-.3.8-.3 1.7 0 2.5.1.4.2.9.1 1-.2.2-.7 0-1.1-.1l-.5-.1c-.5-1.1-1.7-1.9-2.9-1.9 0-.3-.1-.6-.2-.9-.7-1.8-2.6-2.9-4.5-2.6-.5.1-.9.4-1.2.7-.3-.5-.7-.8-1.2-1.1-1.1-.6-2.5-.7-3.7-.3-.6.2-1.2.6-1.5 1.3-.4.9.3 2 1.6 4 .1.2.3.4.4.6-.3.1-.7.3-1 .4-.4.2-.8.6-1 1-.1.4-.1.8-.1 1.3C2 20.8 7.2 26 13.6 26h.8C20.8 26 26 20.8 26 14.4v-.2c-.4-.8-1.1-1.4-1.9-1.8zm-6.5.4c.7.2 1.4.4 1.9-.1s.3-1.1.1-1.8c-.3-.6-.3-1.3 0-1.9.3-.6.8-1 1.4-1.1.4-.1.8-.1 1.2.1.8.4.8 1.9.6 2.8-.1.3-.3.6-.5.8-.2.3-.5.6-.3 1s.6.4 1 .4c.3 0 .6.1.8.2.4.2.8.5 1 .8h-4l.3-1.5c.2-.9.5-1.9.8-2.8l-.8-.3c-.3.9-.6 1.9-.8 2.8-.1.6-.2 1.1-.3 1.7h-2.6c.2-.3.2-.7.2-1.1zm-2.8-1.2v-.8c.9.2 1.7.8 1.9 1.7l-.8.3.3.8.7-.2c0 .2-.1.4-.1.6h-4.5c-.3-.3-.3-.5-.3-.8V13l.7.2.3-.8-.7-.2c.3-.7 1-1.2 1.8-1.3v.8h.7zM9.9 7.3c1.5-.2 3 .7 3.5 2.1.1.2.1.5.2.7-1.7.4-2.7 2.2-2.3 3.9H9.4c.2-.2.3-.4.5-.6.9-1.2 1.5-2.7 1.7-4.2l-.8-.1c-.1 1.4-.7 2.7-1.5 3.8 0 0 0 .1-.1.1.6-1.6.5-3.5-.2-5.1.2-.3.5-.5.9-.6zm-7.1.1c.2-.4.6-.7 1.1-.8 1-.3 2.1-.3 3 .2C8.8 7.9 9.2 11 8.3 13c0 .1-.1.1-.1.2-.1-.3-.2-.6-.3-1-.7-1.9-1.8-3.6-3.3-5l-.5.7c1.4 1.2 2.5 2.8 3.1 4.6.2.5.3 1 .4 1.5h-.7c-.9-1.1-1.8-2.2-2.5-3.4-1.2-1.8-1.8-2.7-1.6-3.2zm.1 6c.1-.3.4-.5.6-.6.3-.2.7-.3 1.1-.5.4.6.8 1.2 1.3 1.7h-3c-.1-.2-.1-.4 0-.6zm11.5 11.8h-.8C7.8 25.2 3 20.6 2.8 14.8h22.4c-.3 5.8-5 10.4-10.8 10.4z'
				/>
				<path id='Rectangle_3861' className='st0' d='M14 12.4h.8v.8H14z' />
				<path
					id='Path_39533'
					className='st0'
					d='M14.8 6.8v.8c0 .2.2.4.4.4h1.6c2 0 3.6-1.6 3.6-3.6v-.8c0-.2-.2-.4-.4-.4h-1.6c-2 0-3.6 1.6-3.6 3.6zM18.4 4h1.2v.4c0 1.5-1.3 2.8-2.8 2.8h-.5l2-1.7-.5-.6-2.1 1.8C15.6 5.2 16.9 4 18.4 4z'
				/>
				<path
					id='Path_39534'
					className='st0'
					d='M11.2 4.4c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2-.5-1.2-1.2-1.2-1.2.5-1.2 1.2zm1.6 0c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4z'
				/>
				<path
					id='Path_39535'
					className='st0'
					d='M6 3.2c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2S7.9 2 7.2 2 6 2.5 6 3.2zm1.6 0c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4z'
				/>
				<path
					id='Path_39536'
					className='st0'
					d='m5.5 18.6-.6.4c1.1 1.8 2.7 3.2 4.6 4.2l.3-.7c-1.8-.9-3.3-2.2-4.3-3.9z'
				/>
				<path id='Rectangle_3862' className='st0' d='M10.4 22.8h.8v.8h-.8z' />
			</g>
		</svg>
	)
}

export default FeedingIcon
